export default {
  forgotPassword: 'global.account.forgot-password',
  email: 'global.account.email',
  resetPassword: 'global.account.reset-password',
  sentLink: 'components.views.reset-password-view.enter-email-form.link-sent'
}
